"use client"
/* */
const header = "flow--list--header";
const headerContent = "flow--list--header--header-content";
const actions = "flow--list--header--actions";
const options = "flow--list--header--options";
const mobile = "flow--list--header--mobile";
const desktop = "flow--list--header--desktop";
const action = "flow--list--header--action";
const headerStyles = {
	header: header,
	headerContent: headerContent,
	actions: actions,
	options: options,
	mobile: mobile,
	desktop: desktop,
	action: action
};

export { action, actions, headerStyles as default, desktop, header, headerContent, mobile, options };
//# sourceMappingURL=Header.module.css.mjs.map
